<script>
import PontoColetaForm from '@/components/eta/PontoColetaForm.vue'
import Loading from '@/components/Loading.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import http from '@/utils/http'

export default {
  name: 'EtaPontosForm',
  components: { Loading, PontoColetaForm },
  data() {
    return {
      loading: true,
      etaId: this.$route.params.etaId,
      eta: null,
      tiposDadoColeta: [],
      pontos: [],
      pontosDeleted: [],
    }
  },
  computed: {
    orderedPontos() {
      return [...this.pontos].sort((a, b) => {
        if (a.id == null) {
          return 1
        }

        if (b.id == null) {
          return 1
        }

        return a.nome.localeCompare(b.nome)
      })
    },
  },
  async beforeMount() {
    await this.loadData()

    this.loading = false

    if (this.pontos.length === 0) {
      this.addEmptyPontoColeta()
    }
  },
  methods: {
    async loadData() {
      await Promise.all([this.buscarEta(), this.loadTiposDadoColeta()])
    },
    async buscarEta() {
      await http.eta
        .get(`eta/${this.etaId}`)
        .then((data) => {
          this.eta = data
        })
        .catch(() => {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Erro ao buscar ETA',
            type: Types.DANGER,
          })
        })

      this.pontos = this.eta.pontosColeta
    },
    async loadTiposDadoColeta() {
      this.tiposDadoColeta = await http.eta.get('tipo-coleta')
    },
    addEmptyPontoColeta() {
      this.pontos.push({
        nome: '',
        tempId: (Math.random() + 1).toString(36).substring(7),
        periodicidade: 'DIARIO',
        tiposDadoColeta: [],
        latitude: this.eta.latitude,
        longitude: this.eta.longitude,
      })
    },
    deletar(ponto) {
      let index

      if (ponto.tempId === undefined) {
        index = this.pontos.findIndex((e) => e.id === ponto.id)
      } else {
        index = this.pontos.findIndex((e) => e.tempId === ponto.tempId)
      }

      if (ponto.id != null) {
        this.pontosDeleted.push(ponto)
      }

      this.pontos.splice(index, 1)
    },
    async salvar() {
      if (this.pontos === null || this.pontos.length === 0) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Adicione ao menos um ponto de coleta',
          type: Types.WARNING,
        })

        return
      }

      const result = this.pontos.map((ponto, i) =>
        this.$refs['ponto' + i][0].validateAndGet()
      )

      if (result.some((e) => e[0] === false)) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Preencha todos os campos corretamente',
          type: Types.WARNING,
        })

        return
      }

      const pontos = result
        .map((e) => e[1])
        .map((e) => ({
          ...e,
          coletaParametros: e.coletaParametros.map((parametro) => ({
            tipo: parametro,
            periodicidade: e.periodicidade,
            topico: e.topico,
          })),
        }))

      const pontosCriar = pontos.filter((e) => e.id == null)
      const pontosAtualizar = pontos.filter((e) => e.id != null)

      const criarPromise = pontosCriar.map((e) =>
        http.eta.post(`eta/${this.etaId}/ponto-coleta`, e, false)
      )
      const atualizarPromise = pontosAtualizar.map((e) =>
        http.eta.put(`eta/${this.etaId}/ponto-coleta/${e.id}`, e, false)
      )
      const deletarPromise = this.pontosDeleted.map((e) =>
        http.eta.delete(`eta/${this.etaId}/ponto-coleta/${e.id}`, e.id, false)
      )

      this.loading = true

      await Promise.all([
        ...criarPromise,
        ...atualizarPromise,
        ...deletarPromise,
      ])
        .then(() => {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Pontos de coleta salvos com sucesso',
            type: Types.INFO,
          })
        })
        .catch(() => {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Erro ao salvar',
            type: Types.DANGER,
          })
        })
        .finally(this.loadData)
        .then(() => {
          this.loading = false
        })
    },
  },
}
</script>

<template>
  <div>
    <div class="row" style="align-items: baseline">
      <div class="hover-cursor ml-2 hover-cursor" @click="$router.back()">
        <md-icon class=""> arrow_back </md-icon>
      </div>
      <div class="ml-3">
        <h1 class="md-title">ETA Pontos</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <md-steppers md-active-step="s" md-linear class="remove-box">
          <md-step
            md-label="Cadastro ETA"
            :md-editable="false"
            :md-done="false"
          />

          <md-step
            id="s"
            md-label="Pontos de coleta"
            :md-editable="false"
            :md-done="false"
          />
        </md-steppers>
      </div>
    </div>

    <div class="ml-4">
      <h1 class="md-title">Pontos de coleta</h1>
      <p class="md-subheading">
        Cadastre os pontos que deverão ser coletados e também a sua
        periodicidade abaixo:
      </p>
    </div>

    <div v-if="loading" class="ml-4">
      <loading :loading="loading" :diameter="200" />
    </div>

    <div v-if="!loading" class="ml-4">
      <div
        v-for="(ponto, i) in orderedPontos"
        :key="ponto.id || JSON.stringify(ponto)"
      >
        <ponto-coleta-form
          :ref="'ponto' + i"
          :eta="eta"
          :ponto="ponto"
          :tipos-dado-coleta="tiposDadoColeta"
          @onTrash="(e) => deletar(e)"
        />
      </div>
    </div>

    <div v-if="!loading" class="ml-4">
      <md-button
        class="md-primary md-raised"
        @click="() => addEmptyPontoColeta()"
      >
        <md-icon>add</md-icon>
        Adicionar ponto
      </md-button>
    </div>

    <div v-if="!loading" class="ml-4 mr-5">
      <div class="row" style="flex-direction: row-reverse">
        <md-button class="md-primary md-raised" @click="() => salvar()">
          Salvar
        </md-button>

        <md-button @click="() => $router.back()"> Cancelar </md-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.remove-box > .md-steppers-navigation {
  box-shadow: 0 0 !important;
}

.hover-cursor:hover {
  cursor: pointer;
}
</style>
